"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isIntegrationIoTDataReady = exports.isIntegrationIoTDataFailed = exports.isIntegrationIoTDataTranscoding = exports.isIntegrationIoTData = exports.isCampaignIoTData = exports.isListIoTData = exports.isChannelIoTData = exports.isPlaylistIoTData = exports.isContentIoTData = exports.isIoTValueScreenCommandSuccess = exports.isIoTValueScreenCommand = exports.isIoTValueScreenUpdate = exports.isIoTValueScreen = exports.ScreenIotMessageCommandSuccess = exports.ScreenIotMessageCommand = exports.ScreensIotMessageUpdate = exports.IoTValueType = exports.IoTDataType = exports.EMMiIoTMessage = exports.IoTLunchListContent = void 0;
const integrations_1 = require("./integrations");
/**
 * Lunch list content to be updated when received IoT topic
 */
var IoTLunchListContent;
(function (IoTLunchListContent) {
    IoTLunchListContent["products"] = "products";
    IoTLunchListContent["groups"] = "groups";
})(IoTLunchListContent = exports.IoTLunchListContent || (exports.IoTLunchListContent = {}));
/**
 * IoT messages relating to EMMi integration
 */
var EMMiIoTMessage;
(function (EMMiIoTMessage) {
    /** IoT message containing transfer progress of asset */
    EMMiIoTMessage["EMMiProgress"] = "EMMiProgress";
    /** IoT message for image asset converted successfully */
    EMMiIoTMessage["EMMiImageConverted"] = "EMMiImageConverted";
    /** IoT message for video asset sent to Elastic Transcoder */
    EMMiIoTMessage["EMMiVideoSentToTranscoder"] = "EMMiVideoSentToTranscoder";
    /** IoT message for if selected file already exists in SeeSignage */
    EMMiIoTMessage["EMMiFileExists"] = "EMMiFileExists";
    /** IoT message for error happened while downloading asset */
    EMMiIoTMessage["EMMiDownloadError"] = "EMMiDownloadError";
    /** IoT message for error happened while asset conversion */
    EMMiIoTMessage["EMMiConversionError"] = "EMMiConversionError";
})(EMMiIoTMessage = exports.EMMiIoTMessage || (exports.EMMiIoTMessage = {}));
/** note: this will be deprecated when IoTValueType is fully supported */
var IoTDataType;
(function (IoTDataType) {
    IoTDataType["channel"] = "channel";
    IoTDataType["content"] = "content";
    IoTDataType["list"] = "list";
    IoTDataType["playlist"] = "playlist";
    IoTDataType["campaign"] = "campaign";
    IoTDataType["integration"] = "integration";
    IoTDataType["screen"] = "screen";
})(IoTDataType = exports.IoTDataType || (exports.IoTDataType = {}));
/** Note: all of Iot value types are not yet supported.  */
var IoTValueType;
(function (IoTValueType) {
    IoTValueType["channel"] = "channel";
    IoTValueType["content"] = "content";
    IoTValueType["list"] = "list";
    IoTValueType["playlist"] = "playlist";
    IoTValueType["campaign"] = "campaign";
    IoTValueType["integration"] = "integration";
    IoTValueType["screen"] = "screen";
})(IoTValueType = exports.IoTValueType || (exports.IoTValueType = {}));
/**
 * Screen data update messages
 */
var ScreensIotMessageUpdate;
(function (ScreensIotMessageUpdate) {
    /** Screen is created. */
    ScreensIotMessageUpdate["create"] = "create";
    /** Screen data is updated. */
    ScreensIotMessageUpdate["update"] = "update";
    /** Screen is deleted for database. */
    ScreensIotMessageUpdate["delete"] = "delete";
})(ScreensIotMessageUpdate = exports.ScreensIotMessageUpdate || (exports.ScreensIotMessageUpdate = {}));
/**
 * IoT messages to command screen
 */
var ScreenIotMessageCommand;
(function (ScreenIotMessageCommand) {
    /** Send ping-command to screen. */
    ScreenIotMessageCommand["ping"] = "ping";
    /** Send files-command to screen. */
    ScreenIotMessageCommand["files"] = "files";
    /** Send deleteFiles-command to screen. Screen will delete its media files. */
    ScreenIotMessageCommand["deleteFiles"] = "deleteFiles";
    /** Send restart-command to screen. Screen will restart. */
    ScreenIotMessageCommand["restart"] = "restart";
})(ScreenIotMessageCommand = exports.ScreenIotMessageCommand || (exports.ScreenIotMessageCommand = {}));
/**
 * IoT messages to notify ui/player that task was executed successfully.
 */
var ScreenIotMessageCommandSuccess;
(function (ScreenIotMessageCommandSuccess) {
    /** Screen received ping-command successfully and sent screen status update to backend. */
    ScreenIotMessageCommandSuccess["pingSuccess"] = "pingSuccess";
    /** Screen received files-command successfully and sent updated files data to backend. */
    ScreenIotMessageCommandSuccess["filesSuccess"] = "filesSuccess";
    /** Screen updated its status to backend. */
    ScreenIotMessageCommandSuccess["statusUpdated"] = "statusUpdated";
    /** Can be used in player to check that IoT works. */
    ScreenIotMessageCommandSuccess["heartbeat"] = "heartbeat";
})(ScreenIotMessageCommandSuccess = exports.ScreenIotMessageCommandSuccess || (exports.ScreenIotMessageCommandSuccess = {}));
exports.isIoTValueScreen = (item) => (item === null || item === void 0 ? void 0 : item.type) === IoTValueType.screen;
exports.isIoTValueScreenUpdate = (item) => (item === null || item === void 0 ? void 0 : item.type) === IoTValueType.screen &&
    Object.values(ScreensIotMessageUpdate).includes(item === null || item === void 0 ? void 0 : item.message);
exports.isIoTValueScreenCommand = (item) => (item === null || item === void 0 ? void 0 : item.type) === IoTValueType.screen &&
    Object.values(ScreenIotMessageCommand).includes(item === null || item === void 0 ? void 0 : item.message);
exports.isIoTValueScreenCommandSuccess = (item) => (item === null || item === void 0 ? void 0 : item.type) === IoTValueType.screen &&
    Object.values(ScreenIotMessageCommandSuccess).includes(item === null || item === void 0 ? void 0 : item.message);
exports.isContentIoTData = (item) => (item === null || item === void 0 ? void 0 : item.type) === IoTDataType.content;
exports.isPlaylistIoTData = (item) => (item === null || item === void 0 ? void 0 : item.type) === IoTDataType.playlist;
exports.isChannelIoTData = (item) => (item === null || item === void 0 ? void 0 : item.type) === IoTDataType.channel;
exports.isListIoTData = (item) => (item === null || item === void 0 ? void 0 : item.type) === IoTDataType.list;
exports.isCampaignIoTData = (item) => (item === null || item === void 0 ? void 0 : item.type) === IoTDataType.campaign;
exports.isIntegrationIoTData = (item) => (item === null || item === void 0 ? void 0 : item.type) === IoTDataType.integration;
exports.isIntegrationIoTDataTranscoding = (item) => (item === null || item === void 0 ? void 0 : item.type) === IoTDataType.integration && (item === null || item === void 0 ? void 0 : item.status) === integrations_1.EMMiIntegrationStatus.transcoding;
exports.isIntegrationIoTDataFailed = (item) => (item === null || item === void 0 ? void 0 : item.type) === IoTDataType.integration && (item === null || item === void 0 ? void 0 : item.status) === integrations_1.EMMiIntegrationStatus.failed;
exports.isIntegrationIoTDataReady = (item) => (item === null || item === void 0 ? void 0 : item.type) === IoTDataType.integration && (item === null || item === void 0 ? void 0 : item.status) === integrations_1.EMMiIntegrationStatus.ready;
//# sourceMappingURL=iot.js.map